import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=4ef734eb&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef734eb",
  null
  
)

export default component.exports